const encodeSegment = (value: string, label: string): string => {
  const normalized = value.trim();
  if (!normalized) throw new RangeError(`${label} is required.`);
  return encodeURIComponent(normalized);
};

export const aiApiPaths = {
  briefing: '/api/ai/briefing',
  leadScore: (leadId: string) => `/api/ai/lead-score/${encodeSegment(leadId, 'Lead id')}`,
  leadScores: '/api/ai/lead-scores',
  dealScores: '/api/ai/deal-scores',
  callOptimizer: '/api/ai/call-optimizer',
  nicheIntelligence: '/api/ai/niche-intelligence',
  anomalies: '/api/ai/anomalies',
  scrapeAdvisor: '/api/ai/scrape-advisor',
  chat: '/api/ai/chat',
  chatStream: '/api/ai/chat/stream',
  greeting: '/api/ai/greeting',
  followUpDraft: '/api/ai/follow-up-draft',
  meetingAgenda: '/api/ai/meeting-agenda',
  notifications: (limit = 50) => {
    if (!Number.isInteger(limit) || limit < 1 || limit > 100) {
      throw new RangeError('Notification limit must be an integer from 1 to 100.');
    }
    return `/api/notifications?limit=${limit}`;
  },
  notificationRead: (id: string) => `/api/notifications/${encodeSegment(id, 'Notification id')}/read`,
  notificationsReadAll: '/api/notifications/read-all',
  upload: '/api/upload',
} as const;

export function allAiApiPathSamples(segment = 'sample'): string[] {
  return [
    aiApiPaths.briefing, aiApiPaths.leadScore(segment), aiApiPaths.leadScores,
    aiApiPaths.dealScores, aiApiPaths.callOptimizer, aiApiPaths.nicheIntelligence,
    aiApiPaths.anomalies, aiApiPaths.scrapeAdvisor, aiApiPaths.chat,
    aiApiPaths.chatStream, aiApiPaths.greeting, aiApiPaths.followUpDraft,
    aiApiPaths.meetingAgenda, aiApiPaths.notifications(),
    aiApiPaths.notificationRead(segment), aiApiPaths.notificationsReadAll, aiApiPaths.upload,
  ];
}
